import React from "react";
import { Button } from "../Button";

import "./FilterDate.scss";
import PropTypes from "prop-types";
import { LAYOUT } from "../../utils";

function formatDate(d) {
  return d.toISOString().split("T")[0];
}

// TODO These should be provided as props so
// that they are updated with the Reset All Filters button
const { START, END } = LAYOUT.TIMELINE.FILTERS.TIME;

export default function FilterDate({ start, end, onChange = () => {} }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dateStart, setDateStart] = React.useState(formatDate(start));
  const [dateEnd, setDateEnd] = React.useState(formatDate(end));

  const toggleOpen = () => setIsOpen(!isOpen);
  const onClick = () => {
    onChange({
      start: new Date(dateStart),
      end: new Date(dateEnd),
    });
  };
  const onReset = () => {
    setDateStart(formatDate(START));
    setDateEnd(formatDate(END));
    onChange({
      start: START,
      end: END,
    });
  };

  const color = "white";
  const buttonClasses = "rounded block-font uppercase p0 h6";

  return (
    <div className="filter-date pointer-events filter-group block-font flex flex-column block-font h4 my2">
      <div className="flex flex-row items-center justify-between mb1">
        <div
          className="filter-date-toggle flex flex-row items-center"
          onClick={toggleOpen}
        >
          <svg
            className={`filter-group__indicator ${
              isOpen ? `filter-group__indicator--expanded` : ``
            }`}
            fill={color}
            role="img"
            aria-label="expand filter group"
          >
            <use xlinkHref="#chevron-down" />"
          </svg>
          <span className="uppercase pointer bold">Date Range</span>
        </div>
        <Button
          className={`filter-date-reset ${buttonClasses}`}
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      {isOpen && (
        <>
          <div className="flex justify-between mb1 ml2 items-center">
            <label htmlFor="filter-date-start">Start</label>
            <input
              className="bg-transparent block-font color-secondary col-12 pb1 h4"
              id="filter-date-start"
              type="date"
              value={dateStart}
              onChange={(ev) => setDateStart(ev.target.value)}
            />
          </div>
          <div className="flex justify-between mb1 ml2 items-center">
            <label htmlFor="filter-date-end">End</label>
            <input
              className="bg-transparent block-font color-secondary col-12 pb1 h4"
              id="filter-date-end"
              type="date"
              value={dateEnd}
              onChange={(ev) => setDateEnd(ev.target.value)}
            />
          </div>
          <div className="flex justify-end actions mt1">
            <Button
              className={`filter-date-submit ${buttonClasses}`}
              onClick={onClick}
            >
              Search
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

FilterDate.propTypes = {
  start: PropTypes.object,
  end: PropTypes.object,
  onChange: PropTypes.func,
};
